import CategoryImagePage from '@/modules/category/add-category/category-image/page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/category/add-category/category-image'
)({
  validateSearch: searchSchema,
  component: AddImagePage,
});

function AddImagePage() {
  return <CategoryImagePage />;
}
